import { useState, useEffect } from 'react'

import { requestService } from '../services'

const useBudgetsRequested = (id?: string) => {
  const [data, setData] = useState<any[] | null>(null)

  useEffect(() => {
    getById(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const getById = async (id?: string) => {
    setData(null)
    const resp = await requestService.getBudgetsRequested(id)
    setData(resp.data)
  }

  return {
    data,
    getById
  }
}

export { useBudgetsRequested }